import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

import useDefaultCustomDomain from "./useDefaultCustomDomain";

/**
 * Hook to get the shop's domain for display purposes.
 * Returns the custom domain if available, otherwise the shop domain prefix.
 */
const useShopDomain = () => {
  const { project } = useCurrentProjectContext();
  const defaultCustomDomain = useDefaultCustomDomain();

  if (defaultCustomDomain?.value) {
    return defaultCustomDomain.value;
  }

  if (project?.shopDomainPrefix) {
    return `${project.shopDomainPrefix}.reploshops.com`;
  }

  return "your-store.reploshops.com";
};

export default useShopDomain;
